import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { from, Observable } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { OrganisationsService } from "../../../modules/organisations/organisations.service";
import { LocalStorageService } from "../../localStorage/localStorage.service";

@Injectable({
    providedIn: 'root'
})
export class JobsGuard 
{
    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _organisationsService: OrganisationsService,
        private _localStorageService: LocalStorageService,
        private _router: Router
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
        const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        return this._check(redirectUrl);
    }

    /**
     * Can activate child
     *
     * @param childRoute
     * @param state
     */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        return this._check(redirectUrl);
    }

    /**
     * Can load
     *
     * @param route
     * @param segments
     */
    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean
    {
        return this._check('/');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param redirectURL
     * @private
     */
    private _check(redirectURL: string): Observable<boolean>
    {
        return from(this._authService.checkAdmin().then((authenticated) => {

            if (!this._organisationsService.organisation) {
                const cachedShowJobs = this._localStorageService.localStorageGetItem('showJobs') === 'true';
                if (!cachedShowJobs) {
                    authenticated = false;
                }
            }
            else if (!this._organisationsService.organisation?.config?.usesJobSystem) {
                authenticated = false;
            }

            if (!authenticated) {
                // Redirect to the dashboard
                this._router.navigate(['dashboard']);
                return false;
            }
            return true;
        }));
    }
}
